import React from 'react'
import Navbar from '../components/Navbar/Navbar';
import AboutMe from '../components/About/AboutMe';
import FooterMe from '../components/Footer/FooterMe';
import 'flowbite'
const About = () => {
  return (
    <>
     <Navbar />
     
      <AboutMe />
     <FooterMe />
    </>
  )
}

export default About